import { html } from '../utils';
export class SecondaryNavigation {
    el;
    menu;
    constructor(el) {
        this.el = el;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.menu = document.getElementById('site-secondary-navigation');
        // Add event listeners and perform initial resize
        this.el.addEventListener('click', this.toggle.bind(this));
        this.menu.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
        window.addEventListener('resize', this.handleResize.bind(this));
        this.update();
    }
    handleResize() {
        this.update();
        if (window.innerWidth >= 1024 && this.expanded)
            this.collapse();
    }
    update() {
        this.menu.style.height = (this.expanded ? window.innerHeight - this.menu.offsetTop : 0) + 'px';
    }
    handleTransitionEnd(event) {
        if (event.target === this.menu && this.expanded) {
            this.menu.classList.remove('overflow-y-hidden');
        }
    }
    get expanded() {
        return this.el.getAttribute('aria-expanded') === 'true';
    }
    toggle() {
        if (this.expanded)
            this.collapse();
        else
            this.expand();
    }
    expand() {
        this.el.classList.add('is-open');
        this.el.setAttribute('aria-expanded', 'true');
        this.update();
        // Disable body scroll
        html?.classList.add('overflow-hidden', 'h-screen', 'sub-menu-open');
    }
    collapse() {
        this.el.classList.remove('is-open');
        this.el.setAttribute('aria-expanded', 'false');
        this.menu.classList.add('overflow-y-hidden');
        this.update();
        // Re-enable body scroll
        html?.classList.remove('overflow-hidden', 'h-screen', 'sub-menu-open');
    }
}
